import { DEFAULT_NURSERY_BRAND_COLOR } from "src/shared/config/src";
import { RootState } from "src/shared/types/src";

export const getHardRefreshLastObservation = (state: RootState) => state?.misc?.refreshLastObservation ?? false;
export const getShowDownloadAppBanner = (state: RootState) => state?.misc?.showDownloadAppBanner ?? true;

export const getColors = (state: RootState) => state?.misc?.themeColors;

export const getBrandBackgroundColor = (appTheme: 'dark' | 'light') => (state: RootState) => state?.misc?.themeColors[appTheme].backgroundColor || DEFAULT_NURSERY_BRAND_COLOR;

export const getBrandForegroundColor = (appTheme: 'dark' | 'light') => (state: RootState) => state?.misc?.themeColors[appTheme].foregroundColor;

export const getIsBrandBorderApplied = (appTheme: 'dark' | 'light') => (state: RootState) => state?.misc?.themeColors[appTheme].showBrandBorder;

export const getBrandBorderColor = (appTheme: 'dark' | 'light') => (state: RootState) => state?.misc?.themeColors[appTheme].borderColor;
